/**
 * Composable for MCP (Model Context Protocol) related functionality
 */
export function useMcp() {
  /**
   * Get the MCP flow ID from URL query parameters
   * @returns The mcp_flow_id parameter value or null if not present
   */
  const getMcpFlowId = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('mcp_flow_id')
  }

  /**
   * Preserve MCP flow ID in a URL if it exists in current URL
   * @param targetUrl - The URL to add the flow ID to
   * @returns The URL with mcp_flow_id parameter if applicable
   */
  const preserveMcpFlowId = (targetUrl: string): string => {
    const mcpFlowId = getMcpFlowId()
    if (!mcpFlowId) return targetUrl
    
    const url = new URL(targetUrl, window.location.origin)
    url.searchParams.set('mcp_flow_id', mcpFlowId)
    return url.toString()
  }

  /**
   * Get the current URL with MCP flow ID preserved if it exists
   * @returns Current URL with mcp_flow_id parameter if applicable
   */
  const getCurrentUrlWithMcpFlow = (): string => {
    return preserveMcpFlowId(window.location.href)
  }

  return {
    getMcpFlowId,
    preserveMcpFlowId,
    getCurrentUrlWithMcpFlow
  }
}
